export default __webpack_public_path__ + "static/media/forgot_pw.b9feab46.png";